import { readJson, request } from './request'

/**
 * Which MyLib is running, and which sources it was built from.
 *
 * Asked of the same `/api/status` the service has always answered, and answered without a session:
 * whoever is working out why something behaves oddly is often not signed in yet. There is this one
 * endpoint for it and no second one — a build that reports itself twice will one day report itself
 * differently in the two places.
 */

/** What the build could not tell, said in the same word by the build, the service and this file. */
export const UNKNOWN = 'unknown'

export interface Status {
  readonly name: string
  readonly version: string
  /** The full commit the build came out of, or {@link UNKNOWN}. */
  readonly commit: string
}

const STATUS_ENDPOINT = '/api/status'

/**
 * Asks the service which build is answering.
 *
 * Every field is defaulted rather than trusted, so an older service that does not know one of them
 * yet leaves a gap instead of breaking the screen it is shown on.
 */
export async function fetchStatus(signal?: AbortSignal): Promise<Status> {
  const response = await request(STATUS_ENDPOINT, { signal })
  const body = await readJson<StatusPayload>(response)

  return {
    name: body.name ?? '',
    version: body.version ?? '',
    commit: body.commit ?? '',
  }
}

/** The shape on the wire, where every field is optional because the wire is not ours to trust. */
interface StatusPayload {
  readonly name?: string
  readonly version?: string
  readonly commit?: string
}
